import {
  SEARCH_CONTACT_REQUEST,
  SEARCH_CONTACT_SUCCESS,
  SEARCH_CONTACT_FAILURE,
  RESET_CONTACT_SEARCH,
  statusType
} from '../../actions'


const initial = {
  data: [],
  status: statusType.IDLE
}

const search = (state = initial, action) => {
  const { payload } = action

  switch (action.type) {
    case SEARCH_CONTACT_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case SEARCH_CONTACT_SUCCESS:
      return {
        ...state,
        data: payload,
        status: statusType.SUCCESS
      }

    case SEARCH_CONTACT_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    case RESET_CONTACT_SEARCH:
      return {
        ...initial
      }

    default:
      return state
  }
}

export default search